module.exports = __webpack_public_path__ + "media/images/emblems/Guendlischwand-coat_of_arms-82e50600cf843c8900a5941ea23f00b9.svg";